import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import webClient from '../../core/web_client';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { CUSTOMER_RESERVATIONS_PATH } from '../../core/constants';

export const returnCustomerReservationAction = createAsyncThunk(
    'reservation/returnCustomerReservationAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.patch(`${ CUSTOMER_RESERVATIONS_PATH }/${ data.customerId }/reservations/${ data.reservationId }/return`, data.form);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const returnCustomerReservationSlice = createSlice({
    name: 'returnCustomerReservationSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(returnCustomerReservationAction.pending, () => STATE__API__STARTED);
        builder.addCase(returnCustomerReservationAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(returnCustomerReservationAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const returnCustomerReservationState = (state) => state.reservation.returnCustomerReservation;
export default returnCustomerReservationSlice.reducer;
